import Axios from 'axios';
import { axiosTemplate } from '../../axiosTemplate';
export const movObservations = {
    endpoints: {
        test: `https://et7e8b80kl.execute-api.us-east-1.amazonaws.com/x`,
        acceptance: `https://36adsf3sx1.execute-api.us-east-1.amazonaws.com/x`,
        prod: `https://4fdx6476c6.execute-api.us-east-1.amazonaws.com/x/`,
    },
    http: {
        getPublicObservations: async ({ stage, metjwt, cancelToken }) => {
            const responseWithSignedS3Url = await axiosTemplate(metjwt, cancelToken).get(`${movObservations.endpoints[stage]}/v0/rest/observation/geo-json-url`);
            return Axios.get(responseWithSignedS3Url.data.url);
        },
    },
};
